var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcZoning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51454 5.46436C1.50485 5.59159 1.5 5.72137 1.5 5.85335V11.1467C1.5 13.2667 2.75333 14.7467 4.66667 14.9667C4.66931 14.9667 4.67196 14.967 4.67461 14.9674L6.27671 6.45016L1.51454 5.46436Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01172 15H10.8118C13.0185 15 14.4985 13.4533 14.4985 11.1466V8.14291L7.5677 6.71387L6.01172 15Z",
    fill: "#979797"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18584 2H10.8125C13.0192 2 14.4992 3.54667 14.4992 5.85333V6.78979L7.18152 5.28954L1.80859 4.17791C2.34599 2.83034 3.57217 2 5.18584 2Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZoning);
export default __webpack_public_path__ + "static/media/ic_zoning.cf8471292dba5965deda7f1f4378ffca.svg";
export { ForwardRef as ReactComponent };